import React from "react";
import Box from "@mui/material/Box";
import {ReactComponent as Boy} from "design_system/src/static/icons/boy.svg";
import {Typography} from "design_system/src";



type ICustomInputTitle = {
  text: string;
  icon?: any;
  subtitle?: string;
  noMargin?: boolean;
}

const CustomInputTitle:React.FC<ICustomInputTitle> = ({text, icon, subtitle, noMargin = false}) => {
  return (
    <Box className="dso_input_cont" sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      color:"#67737e",
    }} >
      <div className={`dso_input_title${noMargin ? " m_y_none" : ""}`}>
        {icon && <div className="dso_input_img" style={{ minWidth: "1.5rem", minHeight: "1.5rem" }}>{icon}</div>}
        <div>
          <Typography scale="small" weight="600" className="dso_input_text" >
            {text}
          </Typography>
          {
            subtitle && (
              <Typography scale="xsmall" weight="400" className="dso_input_subtitle m_l_none m_t_none" >
                {subtitle}
              </Typography>
            )
          }
        </div>
      </div>
    </Box>
  );
};

export default CustomInputTitle;
